<template>
  <div class="tags-view">
    <button
      type="button"
      class="tags-view__toggle"
      :aria-label="collapsed ? '展开菜单' : '收起菜单'"
      :aria-expanded="!collapsed"
      :title="collapsed ? '展开菜单' : '收起菜单'"
      @click="$emit('toggle-sidebar')"
    ><el-icon><Expand v-if="collapsed" /><Fold v-else /></el-icon></button>
    <nav ref="tabList" class="workspace-tabs" role="tablist" aria-label="已打开的页面">
      <div
        v-for="tab in tabs"
        :key="tab.path"
        class="workspace-tab"
        :class="{ 'is-active': activePath === tab.path }"
      >
        <button
          type="button"
          role="tab"
          class="workspace-tab__label"
          :aria-selected="activePath === tab.path"
          :tabindex="activePath === tab.path ? 0 : -1"
          :title="tab.title"
          @click="$emit('select', tab)"
          @keydown="handleKey($event, tab)"
        ><el-icon v-if="tab.path === '/dashboard'"><House /></el-icon>{{ tab.title }}</button>
        <button
          v-if="tab.path !== '/dashboard'"
          type="button"
          class="workspace-tab__close"
          :aria-label="`关闭${tab.title}`"
          :title="`关闭${tab.title}`"
          @click="$emit('close', tab)"
        ><el-icon><Close /></el-icon></button>
      </div>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { Close, Expand, Fold, House } from "@element-plus/icons-vue";
import { nextTick, ref, watch } from "vue";
import type { WorkspaceTab } from "@/composables/useWorkspaceTabs";

const props = defineProps<{ tabs: WorkspaceTab[]; activePath: string; collapsed: boolean }>();
const emit = defineEmits<{
  select: [tab: WorkspaceTab];
  close: [tab: WorkspaceTab];
  'toggle-sidebar': [];
}>();
const tabList = ref<HTMLElement>();

watch(() => props.activePath, async () => {
  await nextTick();
  tabList.value?.querySelector('[aria-selected="true"]')?.scrollIntoView?.({ block: "nearest", inline: "nearest" });
});

function handleKey(event: KeyboardEvent, tab: WorkspaceTab) {
  const index = props.tabs.indexOf(tab);
  let target: WorkspaceTab | undefined;
  if (event.key === "ArrowRight") target = props.tabs[(index + 1) % props.tabs.length];
  if (event.key === "ArrowLeft") target = props.tabs[(index - 1 + props.tabs.length) % props.tabs.length];
  if (event.key === "Home") target = props.tabs[0];
  if (event.key === "End") target = props.tabs.at(-1);
  if (event.key === "Delete" && tab.path !== "/dashboard") {
    event.preventDefault();
    emit("close", tab);
  }
  if (!target) return;
  event.preventDefault();
  emit("select", target);
  const targetIndex = props.tabs.indexOf(target);
  void nextTick(() => tabList.value?.querySelectorAll<HTMLButtonElement>('[role="tab"]')[targetIndex]?.focus());
}
</script>
